import { render, staticRenderFns } from "./CollapseDivMain.vue?vue&type=template&id=42970204&scoped=true&"
import script from "./CollapseDivMain.vue?vue&type=script&lang=js&"
export * from "./CollapseDivMain.vue?vue&type=script&lang=js&"
import style1 from "./CollapseDivMain.vue?vue&type=style&index=1&id=42970204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42970204",
  null
  
)

export default component.exports